// extracted by mini-css-extract-plugin
module.exports = {"cta":"_1aoTHRqG","disabled":"_3dlCnrCg","primary":"i-fj7fop","transparent":"_1fju9H96","secondary":"_3SSfnSXf","fullWidth":"EmJmVgyW","small":"_1fOTz1zT","spinner":"VX4ZiAdc"};